import { Routes } from '@angular/router';
import { InvoicesComponent } from '../pages/invoices/invoices.component';
import { CreateQuoteComponent } from '../pages/create-quote/create-quote.component';
import { PermissionGuard } from '../guards/permission.guard';

export const invoiceModuleBaseRoute = 'invoices';

export const invoiceModuleRoutes = {
  create: 'create',
};

export const INVOICE_ROUTES: Routes = [
  {
    path: '',
    component: InvoicesComponent,
    canActivate: [PermissionGuard],
    data: { requireOneOf: ['VIEW_INVOICES', 'VIEW_ALL_INVOICES'] }
  },
  {
    path: invoiceModuleRoutes.create,
    component: CreateQuoteComponent,
    canActivate: [PermissionGuard],
    data: { requireOneOf: ['EDIT_ALL_INVOICES'] }
  }
];
